// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__daS4x","description":"styles_description__UwqRO"};